<template>
  <g clip-path="url(#calendar)">
    <path
      d="M14 2h-.667V.666A.667.667 0 0012.667 0H12a.667.667 0 00-.667.666V2H4.667V.666A.667.667 0 004 0h-.667a.667.667 0 00-.666.666V2H2C.897 2 0 2.897 0 4v10c0 1.102.897 2 2 2h12c1.103 0 2-.898 2-2V4c0-1.103-.897-2-2-2zm.667 12c0 .367-.3.666-.667.666H2A.668.668 0 011.333 14V6.693h13.334v7.306z"
    />
  </g>
  <defs>
    <clipPath id="calendar"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath>
  </defs>
</template>
